"use strict";
export const BindFormEdit = (mock) => {
  mock.onGet("/v7/edit_shop").reply((config) => {
    let response = {
      "model": "shop.form",
      "autoCookieSync": true,
      "name": "\u9ED8\u8BA4\u5E97\u94FA",
      "guid": "shop_638f4a0f5d174716be0f2b08bd085864",
      "password": null,
      "account": null,
      "company_name": null,
      "is_auto_cookie_sync": true,
      "lock_account": false,
      "ui_language": "en-US",
      "mode": "use_vd",
      "useragent": "Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/75.0.3770.100 Safari/537.36",
      "platform_id": "ebusiness_platform_1a811442121540b898c4432a9413338d",
      "sub_platforms": [],
      "create_env_setting": true,
      "ebusiness_id": "ebusiness_5a8e8d68466f4474ab30fe7be1a4800e",
      "code": "shop",
      "resolution_mode": "use_vd",
      "screen": null,
      "shop_lock": false,
      "safety_protection": false,
      "safety_mark": true,
      "platform_style": "EBusiness",
      "ebusiness_type": "EBusiness"
    };
    return [200, response];
  });
};
